
export const environment = {
    production: false,
    authApiUrl: 'https://qa.fitnesslabs.me/user-management',
    apiURL: 'https://qa.fitnesslabs.me/user-management',
    baseUrl: 'https://qa.fitnesslabs.me',
    emailPostFix: '@qa.fitnesslabs.me',
    filesApiUrl: 'https://dev.fitnesslabs.me/gcs',
    cdnUrl: 'https://cdn.fitnesslabs.me/dev/gcs',
    recaptchaKey: '6Lf8wgEgAAAAAHly0j9e51Uzi6dZ5PvyqDw9O9PB',
    gaMeasurementId: 'G-5Q8FLFQDDV',
    stripePublishableKey: 'pk_test_51QepIGG4bdBRwELsZZ9tJzpGY2Zwu5iRDUTjaBSD4N8q3T91jTUtFyU9NkbD7VXNlH4epj0IGrqHHW8sLNh33S3D002eIZB36l',
    placesApiKey: 'AIzaSyBaKgb5XgCiSjaPg0p3-IRChjjCyE94LQY',
    firebase: {
        apiKey: "AIzaSyBb81dDo873cSBPkzKSoj0zIexoH16blJI",
        authDomain: "noble-aquifer-439320-u8.firebaseapp.com",
        projectId: "noble-aquifer-439320-u8",
        storageBucket: "noble-aquifer-439320-u8.firebasestorage.app",
        messagingSenderId: "756109741167",
        appId: "1:756109741167:web:c3110adca4072a03c2119a"
    }
};
